import { AffiliateMembersPagination, CommissionDataResponse, CustomerAffiliatesResponse } from 'data/AffiliateMember';
import { get, putFormData } from 'lib/API';

export const loadAffiliateMembers = async (
  [size, page, offset, brandCode, searchTerm]: any[],
  { token }: any
): Promise<AffiliateMembersPagination> => {
  return await get('v1/affiliateMembers', token, { size, page, offset, brandCode, searchTerm });
};

export const loadCustomerAffiliates = async (
  [customerId, brandCode]: any[],
  { token }: any
): Promise<CustomerAffiliatesResponse> => {
  return await get(`v1/affiliateMembers/${customerId}/affiliates`, token, { brandCode });
};

export const loadCommissionData = async (
  [customerId, customerAffiliateId]: any[],
  { token }: any
): Promise<CommissionDataResponse> => {
  return await get(`v1/affiliateMembers/${customerId}/commission-data`, token, { customerAffiliateId });
};

export const updateTransactionStatus = async (
  [customerAffiliateId, transactionIds, brandId, action, file]: any[],
  { token }: any
): Promise<any> => {
  return await putFormData('v1/affiliateMembers/transactions/status', {
    customerAffiliateId,
    transactionIds: JSON.stringify(transactionIds),
    brandId,
    action,
    ...(file ? { imageFile: [file] } : {})
  }, token);
};
